import React from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'

import './style.css.scss'

const MIN_DISTANCE_FROM_SCREEN_BOTTOM = 30
const DISTANCE_FROM_SCREEN_BOTTOM_FIX = 50
const MIN_DISTANCE_FROM_SCREEN_LEFT = 50
const DISTANCE_FROM_SCREEN_LEFT_FIX = 100
const DELAY_DURATION = 500

class TooltipContent extends React.Component {
  componentDidMount() {
    this.isMobile = FollozeState.platform == 'mobile';
    this.tooltip = document.createElement("div")
    document.body.appendChild(this.tooltip)
    this.renderTooltipContent()
  }

  componentDidUpdate() {
    this.renderTooltipContent()
  }

  componentWillUnmount() {
    ReactDom.unmountComponentAtNode(this.tooltip)
    document.body.removeChild(this.tooltip)
  }

  handleMouseEnter = () => {
    this.props.onHoverChange(true)
  }

  handleMouseLeave = () => {
    this.props.onHoverChange(false)
  }

  renderTooltipContent = () => {
    if(this.isMobile){
      return
    }
    ReactDom.render(
      <div
        className={`
          infotip-content
          ${!this.props.element ? 'text' : ''}
          ${this.props.className}
          ${this.props.isInteractive ? 'interactive' : ''}
          ${this.props.lightMode ? 'light' : ''}
        `}
        style={{
          position: "absolute",
          ...this.props.coordinates
        }}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        {
          this.props.element ? this.props.element : <p>{this.props.text}</p>
        }
      </div>,
      this.tooltip
    )
  }

  render() {
    return null
  }
}


class Tooltip extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      element: null,
      isHovering: false
    }
  }

  componentWillUnmount(){
    clearTimeout(this.hideTooltipTimer)
    clearTimeout(this.handleMouseEnterTimer)
    clearTimeout(this.handleMouseLeaveTimer)
  }

  showTooltip = (element) => {
    if (!this.state.isHovering) {
      return
    }
    this.setState({ isOpen: true, element })
  }

  hideTooltip = () => {
    if (this.state.isHovering) {
      this.hideTooltipTimer = setTimeout(this.hideTooltip, DELAY_DURATION)
      return
    }
    this.setState({ isOpen: false, element: null })
  }

  withDelay = (isDelay) => {
    return isDelay ? DELAY_DURATION : 0
  }

  handleMouseEnter = (e) => {
    this.setState({ isHovering: true })
    if (this.props.onMouseEnter) {
      this.props.onMouseEnter(e)
    }
    const element = e.target
    this.handleMouseEnterTimer = setTimeout(
      () => this.showTooltip(element),
      this.withDelay(this.props.delayOnEnter)
    )
  }

  handleMouseLeave = (e) => {
    this.setState({ isHovering: false })
    if (this.props.onMouseLeave) {
      this.props.onMouseLeave(e)
    }
    this.handleMouseLeaveTimer = setTimeout(
      () => this.hideTooltip(),
      this.withDelay(this.props.delayOnLeave)
    )
  }

  handleHoverOnContent = (isHovering) => {
    if (!this.props.isInteractiveContent) {
      return
    }

    this.setState({ isHovering: isHovering })
  }

  getElementCoordinates = () => {
    const box = this.state.element.getBoundingClientRect();
    if(box.width == 0 && box.height == 0){
      return {
        display: 'none',
      }
    }

    return {
      top: Math.round(box.bottom +  window.scrollY),
      left: Math.round(box.left + window.scrollX)
    }
  }

  render() {
    return (
      <div className='infotip-container'
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}>
        { React.cloneElement(this.props.children, this.isMobile
          ? {}
          : {
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            })
        }
        { this.state.isOpen && (this.props.text || this.props.element) && (
          <TooltipContent
            className={this.props.className}
            coordinates={this.getElementCoordinates()}
            text={this.props.text}
            element={this.props.element}
            onHoverChange={this.handleHoverOnContent}
            isInteractive={this.props.isInteractiveContent}
            lightMode={this.props.lightMode} />
        )}
      </div>
    )
  }
}

Tooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  element: PropTypes.element,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  className: PropTypes.string,
  isInteractiveContent: PropTypes.bool,
  delayOnEnter: PropTypes.bool,
  delayOnLeave: PropTypes.bool,
  ignoreOverflow: PropTypes.bool,
  lightMode: PropTypes.bool
}

Tooltip.defaultProps = {
  isInteractiveContent: false,
  delayOnEnter: true,
  delayOnLeave: true,
  ignoreOverflow: false
}

export default Tooltip